module.exports = __webpack_public_path__ + "img/bg.cf247eec.jpg";